import { Project } from "./Project"


export class FileUploadRoot {
  projects: Project[]
  total: number
  syncTime:Date
}
